import React from 'react';
import PropTypes from 'prop-types';
import { ProductItemContext } from './ProductItemContext.js';
import { ProductItemType as Type } from './ProductItemType.js';

import styles from './ProductItemWrapper.module.scss';

const ProductItemWrapper = ({ children }) => {
    const { type } = React.useContext(ProductItemContext);
    return (
        <div className={`${styles['product-wrapper-component']} ${styles[type || Type.Default]}`}>
            {children}
        </div>
    );
};
ProductItemWrapper.propTypes = {
    children: PropTypes.any,
};

export default ProductItemWrapper;
